import React, { useState } from "react";
import { token } from "../../API";
import axios from "axios";
const CreateTag = ({ callback }) => {
  const [uztag, setUzTag] = useState("#");
  const [engTag, setEngTag] = useState("#");
  const [ruTag, setRuTag] = useState("#");
  const createNewTag = () => {
    if (ruTag !== "#" && engTag !== "#" && uztag !== "#") {
      let tagtoAdd = {
        textEn: engTag,
        textRu: ruTag,
        textUz: uztag,
      };
      setTag(tagtoAdd);

      setUzTag("#");
      setEngTag("#");
      setRuTag("#");
    }
  };
  const setTag = async (body) => {
    const url = `http://164.90.236.174:1988/koinot/tag`;
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const res = await axios.post(url, body, headers);
      callback(res.data.objectKoinot);

      return res;
    } catch (error) {
      console.error(error);
      return { error: true, error };
    }
  };
  return (
    <div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          createNewTag();
        }}
        className="form-group w-100"
      >
        <br />
        <label htmlFor="uztag">O'zbekcha</label>
        <input
          type="text"
          className="form-control"
          id="uztag"
          value={uztag}
          placeholder="in english"
          onChange={(e) => setUzTag(e.target.value)}
        />
        <br />
        <label htmlFor="engtag">In English</label>
        <input
          type="text"
          className="form-control"
          id="engtag"
          value={engTag}
          placeholder="in english"
          onChange={(e) => setEngTag(e.target.value)}
        />
        <br />
        <label htmlFor="rutag">Hа русском</label>

        <input
          type="text"
          className="form-control"
          id="rutag"
          value={ruTag}
          placeholder="на русском"
          onChange={(e) => setRuTag(e.target.value)}
        />

        <button className="btn btn-info">Bazaga yangi tag qo'shish</button>
      </form>
    </div>
  );
};

export default CreateTag;



// WEBPACK FOOTER //
// ./src/Components/CreateTag/index.js